import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "../components/Billing.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FIELDS = [
  ["diocese_name", "Diocese Name", true, "full"],
  ["contact_name", "Contact Name", true],
  ["title", "Title", false],
  ["email", "Email", true],
  ["phone", "Phone", false],
  ["num_parishes", "Number of Parishes", false],
  ["num_clergy", "Number of Clergy", false],
  ["annual_budget", "Estimated Annual Budget (optional)", false],
];

export default function Diocese() {
  const navigate = useNavigate();
  const [form, setForm] = useState({});
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      await axios.post(`${API}/diocese/inquiry`, form);
      setDone(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Could not submit. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="diocese" data-testid="diocese-page">
      <div className="diocese-hero">
        <div className="eyebrow">Diocese Edition</div>
        <h1>Strategic intelligence at diocesan scale.</h1>
        <p>Multi-parish Parish Profile Intelligence™, diocese-wide analytics and dedicated onboarding —
          tailored for the life of your diocese. Request a private demonstration below.</p>
      </div>

      <form className="diocese-form" onSubmit={submit} data-testid="diocese-form">
        {done ? (
          <div className="diocese-done" data-testid="diocese-done">
            <h2>Thank you.</h2>
            <p>Rasaan Hakiem LLC will be in touch shortly to arrange your private demonstration.</p>
            <button className="diocese-submit" onClick={() => navigate("/")} type="button" style={{ maxWidth: 240, margin: "20px auto 0" }}>
              Return Home
            </button>
          </div>
        ) : (
          <>
            {error && <div className="plan-error" data-testid="diocese-error">{error}</div>}
            <div className="diocese-grid">
              {FIELDS.map(([key, label, req, full]) => (
                <div className={`dfield${full ? " full" : ""}`} key={key}>
                  <label>{label}{req ? " *" : ""}</label>
                  <input
                    type={key === "email" ? "email" : "text"}
                    value={form[key] || ""}
                    onChange={set(key)}
                    required={!!req}
                    data-testid={`diocese-${key}`}
                  />
                </div>
              ))}
              <div className="dfield full">
                <label>Current Challenges</label>
                <textarea value={form.current_challenges || ""} onChange={set("current_challenges")} data-testid="diocese-challenges" />
              </div>
              <div className="dfield full">
                <label>Desired Outcomes</label>
                <textarea value={form.desired_outcomes || ""} onChange={set("desired_outcomes")} data-testid="diocese-outcomes" />
              </div>
            </div>
            <button className="diocese-submit" type="submit" disabled={busy} data-testid="diocese-submit">
              {busy ? "Submitting…" : "Request a Private Demonstration"}
            </button>
          </>
        )}
      </form>
    </div>
  );
}
